import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Drawer,
} from "@mui/material";
import {
  Settings,
  Public,
  Lock,
  Devices,
  Logout,
} from "@mui/icons-material";

import { useTranslate } from "../Translate/TranslateContext";
import PasswordSettings from "./PasswordSettings";
import DeviceSettings from "./DeviceSettings";
import RegionalSettings from "./RegionalSettings";

export default function OptionsDrawer({ user, onLogout, setUser }) {
  const { translate } = useTranslate();
  const [open, setOpen] = useState(false);
  const [view, setView] = useState("main");

  const handleClose = () => {
    setView("main");
    setOpen(false);
  };

  return (
    <>
      <IconButton color="primary" onClick={() => setOpen(true)}>
        <Settings />
      </IconButton>

      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: 360,
            bgcolor: "background.default",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Box
          sx={{
            px: 2.5,
            py: 2,
            bgcolor: "primary.main",
            color: "primary.contrastText",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {translate("settings")}
          </Typography>
        </Box>

        <Box
          sx={{
            p: 2.5,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            flex: 1,
            overflowY: "auto",
          }}
        >
          {view === "main" && (
            <>
              <Box
                onClick={() => setView("regional")}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  bgcolor: "background.paper",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  transition: "0.2s",
                  "&:hover": {
                    bgcolor: "neutral.main",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Public fontSize="small" />
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {translate("regional_preferences")}
                  </Typography>
                </Box>

                <Typography variant="body2" sx={{ opacity: 0.6 }}>
                  {translate("open")}
                </Typography>
              </Box>

              <Box
                onClick={() => setView("password")}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  bgcolor: "background.paper",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  transition: "0.2s",
                  "&:hover": {
                    bgcolor: "neutral.main",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Lock fontSize="small" />
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {translate("password")}
                  </Typography>
                </Box>

                <Typography variant="body2" sx={{ opacity: 0.6 }}>
                  {translate("open")}
                </Typography>
              </Box>

              <Box
                onClick={() => setView("devices")}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  bgcolor: "background.paper",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  transition: "0.2s",
                  "&:hover": {
                    bgcolor: "neutral.main",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Devices fontSize="small" />
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {translate("devices")}
                  </Typography>
                </Box>

                <Typography variant="body2" sx={{ opacity: 0.6 }}>
                  {translate("open")}
                </Typography>
              </Box>

              <Box sx={{ mt: "auto" }}>
                <Button
                  startIcon={<Logout />}
                  variant="contained"
                  color="error"
                  fullWidth
                  onClick={onLogout}
                  sx={{ borderRadius: 2, fontWeight: 600 }}
                >
                  {translate("sign_out")}
                </Button>
              </Box>
            </>
          )}

          {view === "regional" && (
            <RegionalSettings
              user={user}
              onBack={() => setView("main")}
              setUser={setUser}
            />
          )}

          {view === "password" && (
            <PasswordSettings onBack={() => setView("main")} user={user} />
          )}

          {view === "devices" && (
            <DeviceSettings
              onBack={() => setView("main")}
              user={user}
              onLogout={onLogout}
            />
          )}
        </Box>
      </Drawer>
    </>
  );
}